import React from 'react';
import { agencyProfile } from '../agencyProfiles';
import { fmtDotDate } from '../alertHelpers';

// The banner inside an agency alert's framed header (10-28 mockups): the
// agency seal on the left, its full name beside it, and a caption row along
// the bottom with the alert type (Public Service Announcement / Consumer
// Alert) and the alert's reference, date and source link. Keeps the same
// minimum height as the ScamWire pages' hero photo so every frame matches.
const AgencyBanner = ({ alert }) => {
  const agency = agencyProfile(alert.source);
  return (
    <div className="min-h-[340px] flex flex-col">
      <div className="flex flex-1 items-center gap-8 md:gap-12 py-6">
        {agency.seal && (
          <img
            src={agency.seal}
            alt=""
            className="h-[150px] w-[150px] md:h-[170px] md:w-[170px] flex-shrink-0 object-contain"
          />
        )}
        <div className="min-w-0">
          <h2 className="text-3xl xl:text-4xl font-bold text-black leading-tight">{agency.name}</h2>
          {alert.source === 'ftc' && (
            <p className="text-2xl xl:text-3xl font-bold text-black mt-1">Consumer Alert</p>
          )}
        </div>
      </div>

      <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 text-lg text-black">
        <span>{agency.kind}</span>
        <span className="flex flex-wrap items-baseline gap-x-6 gap-y-1 text-base">
          {alert.psa_number && <span>PSA / {alert.psa_number}</span>}
          <span>Date Issue / {alert.published_at ? fmtDotDate(alert.published_at) : '—'}</span>
          {alert.source_url && (
            <a
              href={alert.source_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              View original source &#8599;
            </a>
          )}
        </span>
      </div>
    </div>
  );
};

export default AgencyBanner;
